import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { super_admin } from '../../routers/AppRouter';

export const ProtectedRoute = ({ children }) => {
    const { auth } = useAuth();

    if (!auth?.isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    const location = useLocation();

    if (auth?.role == "super_admin") {
        if (super_admin.includes(window.location.pathname)) {
            return children
        }
        const from = '/students/logs';
        return <Navigate to={from} replace state={{ from: location }} />;
    }
    if (auth?.role != "super_admin" && super_admin.includes(window.location.pathname)) {
        const from = location.state?.from?.pathname || '/';
        return <Navigate to={from} replace state={{ from: location }} />;
    }

    return children
};
